import Grid from '@material-ui/core/Grid'
import { graphql } from 'gatsby'
import React from 'react'
import styled from 'styled-components'

import useSiteSettings from '../../../../../../hooks/useSiteSettings'
import BodyPortableText from '../../../../../sanity-page/BodyPortableText'

export interface DispensaryBannerTextDisclaimerProps {
  className?: string
}

const StyledBodyPortableText = styled(BodyPortableText)`
  p {
    font-size: 13px;
    margin: 0 0 0 5px;
  }
`

const DispensaryBannerTextDisclaimer: React.FC<DispensaryBannerTextDisclaimerProps> = ({
  className,
}) => {
  const { _rawDispensaryBannerTextDisclaimer: dispensaryBannerTextDisclaimer } = useSiteSettings()
  return dispensaryBannerTextDisclaimer ? (
    <Grid item xs={12}>
      <StyledBodyPortableText className={className} blocks={dispensaryBannerTextDisclaimer} />
    </Grid>
  ) : null
}

export const dispensaryBannerTextDisclaimerFragment = graphql`
  fragment dispensaryBannerTextDisclaimer on SanitySiteSettings {
    _rawDispensaryBannerTextDisclaimer
  }
`

export default DispensaryBannerTextDisclaimer
